import ProductPage from "../components/ProductPage";
import { IMAGES } from "../lib/site";

const config = {
  slug: "coconut-shell-shisha-charcoal",
  label: "PRODUCT 01",
  category: "Shisha / Hookah Charcoal",
  h1: "Premium Indonesian Coconut Shell Shisha Charcoal Briquettes",
  tagline: "Coconut shell charcoal briquettes for shisha and hookah applications — export-ready from Indonesia.",
  specificationNote: "Reference specifications are provided for buyer review. Final technical values are confirmed against the applicable production batch and COA.",
  burningTimeNote: "Reference burning time: 60–120 minutes. Actual performance may vary according to size, airflow, application and batch specification. Final reference is confirmed per batch.",
  subheading: "Export-ready coconut shell charcoal sourced from selected Indonesian manufacturing partners.",
  description:
    "HAQILA supplies coconut shell charcoal briquettes for international shisha and hookah markets through selected Indonesian manufacturing partners.",
  quoteProduct: "Coconut Shell Shisha Charcoal Briquettes",
  heroImage: IMAGES.variantShishaCube,
  heroAlt: "Cube coconut shell shisha charcoal briquettes from Indonesia",
  keySpecs: [
    { label: "Shape / Size", value: "Cube 2.5×2.5×2.5 cm" },
    { label: "Fixed Carbon", value: "≥ 80%" },
    { label: "Ash Content", value: "1.9–2.5%" },
    { label: "Moisture", value: "Max 6%" },
    { label: "Burning Time", value: "60–120 min" },
  ],
  overview: [
    "HAQILA supplies Indonesian coconut shell shisha charcoal briquettes to international importers, wholesalers and distributors. Your shisha and hookah charcoal supply is sourced through selected Indonesian manufacturing partners.",
    "Launching with 3 core shapes — Cube, Cube with Hole and Hexagonal Flower with Hole. Each order is matched to a manufacturing partner and specifications are confirmed per batch COA before order confirmation.",
    "Wholesale shisha charcoal and private label requirements are reviewed by specification, packaging and order quantity. HAQILA coordinates documentation and export shipment — one sourcing and export partner from inquiry to delivery.",
  ],
  applications: [
    "Shisha and hookah lounges",
    "Shisha charcoal importers and wholesalers",
    "HoReCa and hospitality distributors",
    "Private-label retail programs",
    "International trading companies",
  ],
  specs: [
    ["Raw Material", "Coconut shell charcoal"],
    ["Application", "Shisha / hookah"],
    ["Shape", "Cube, Cube with Hole, Hexagonal Flower with Hole"],
    ["Ash Color", "White ash"],
    ["Fixed Carbon", "≥ 80%"],
    ["Moisture", "≤ 6%"],
    ["Ash Content", "1.9 – 2.5%"],
    ["Burning Time", "60 – 120 minutes"],
    ["Packaging", "1 KG / 10 KG / bulk"],
    ["Loading Capacity", "± 18 MT per 20FT / ± 26 MT per 40FT"],
  ],
  shapes: ["Cube", "Cube with Hole", "Hexagonal Flower with Hole"],
  sizeOptions: [
    { name: "Cube", size: "2.5 × 2.5 × 2.5 cm", image: IMAGES.variantShishaCube, alt: "Cube coconut charcoal briquettes for hookah" },
    { name: "Cube with Hole", size: "2.7 × 2.7 × 4.0 cm", image: IMAGES.variantShishaCubeHole, alt: "Coconut shell shisha charcoal briquette with a central hole" },
    { name: "Hexagonal Flower with Hole", size: "2.7 × 2.7 × 5.0 cm", image: IMAGES.variantShishaHexFlower, alt: "Hexagonal flower shisha charcoal briquette with a central hole" },
  ],
  moldingOptions: [
    { shape: "Cube", sizes: "22×22, 25×25, 26×26, 27×27, 28×28 mm" },
    { shape: "Cube with Hole", sizes: "30×30, 40×40, 45×45 mm" },
    { shape: "Hexagonal Flower with Hole (dia. — length adjustable)", sizes: "22, 27, 28 mm" },
  ],
  packaging: [
    { size: "1 KG", copy: "Retail-ready inner boxes with buyer branding options." },
    { size: "10 KG", copy: "Standard bulk carton for wholesale and distribution channels." },
    { size: "Bulk / Custom", copy: "Custom configurations and private-label packaging can be discussed per order." },
  ],
  gallery: [
    { src: IMAGES.charcoalClose, caption: "Product of Indonesian Manufacturing Partners", alt: "Close-up of coconut shell charcoal briquettes for shisha" },
    {
      src: "https://customer-assets-lqy194kg.emergentagent.net/job_sourcing-hub-73/artifacts/lsdb1va8_Coco%20charcoal%20Vietnam.jfif",
      caption: "Burning Performance — Cube Briquettes",
      alt: "Coconut charcoal cubes glowing during burning",
    },
    { src: IMAGES.charcoalDetail, caption: "Product Close-Up", alt: "Glowing charcoal briquettes shown close up" },
    { src: IMAGES.charcoalHero, caption: "Briquette Detail", alt: "Coconut shell charcoal briquettes showing cube shape and surface texture" },
    { src: IMAGES.galleryOwnerWarehouse, caption: "At the source — Indonesia", alt: "HAQILA owner at a charcoal warehouse in Indonesia" },
    { src: IMAGES.galleryGlowingCubes, caption: "Clean, even burn — cube briquettes", alt: "Glowing coconut charcoal cube briquettes" },
    { src: IMAGES.containers, caption: "Export Logistics — Indonesia", alt: "Shipping containers at an export port" },
    { src: IMAGES.packagingBox, caption: "1KG Retail Box", alt: "1 kg coconut charcoal briquette retail packaging" },
    { src: IMAGES.galleryBurnTest, caption: "In-house burn-duration test", alt: "Charcoal briquettes during a burn-duration test" },
    { src: IMAGES.galleryBbqLitRaw, caption: "Rectangular BBQ briquette — lit vs. raw", alt: "Lit and unlit rectangular BBQ charcoal briquettes side by side" },
  ],
};

export default function ShishaCharcoal() {
  return <ProductPage config={config} />;
}
